import { getAuthorData } from "@components/blog/Author";
import theme from "@config/theme";
import { ImgSrc } from "@config/image";

interface AuthorMetaDataProps {
  author: string;
}

const AuthorMetaData = ({ author }: AuthorMetaDataProps) => {
  const authorData = getAuthorData(author);
  return (
    <>
      <div className="author">
        <img
          alt={authorData.name}
          src={ImgSrc(authorData.image)}
          className="author-image"
        />
        <div>
          <span className="author-name">{authorData.name}</span>
          <span className="author-title">{authorData.title}</span>
        </div>
      </div>
      <style jsx>
        {`
          .author {
            display: flex;
            margin: 2rem 0 1rem 0;
          }
          .author-image {
            height: 47px;
            width: 47px;
            border-radius: 50%;
            margin-right: 0.5rem;
            display: flex;
          }
          .author > div {
            display: flex;
            flex-direction: column;
          }
          .author-name {
            font-weight: 500;
            margin-right: 0.25rem;
          }
          .author-title {
            font-size: ${theme.fonts.size.px14};
          }
        `}
      </style>
    </>
  );
};

export default AuthorMetaData;
